import { StructureBuilder } from 'sanity/structure';

export const createStructureConfig = (domainName: string) => {
    return (S: StructureBuilder) => {
        return S.list()
            .title('Content')
            .items([
                // Filter document types to show only those with matching domainName
                ...S.documentTypeListItems()
                    .filter((listItem) => {
                        // Get the schema type
                        const schemaType = listItem.getSchemaType();
                        // Check if this schema has a domainName field
                        // @ts-expect-error - TS doesn't know about the fields property
                        return schemaType?.fields?.some((field) => field.name === 'domainName');
                    })
                    .map((listItem) => {
                        // For each document type with a domainName field, create a filtered list
                        return listItem.child(
                            // Filter documents where domainName matches the current domain
                            S.documentList()
                                .title(listItem.getTitle() || '')
                                .filter('_type == $type && domainName == $domainName')
                                .params({ type: listItem.getId(), domainName }),
                        );
                    }),
                // Include any document types that don't have a domainName field
                ...S.documentTypeListItems().filter((listItem) => {
                    const schemaType = listItem.getSchemaType();
                    // @ts-expect-error - TS doesn't know about the fields property
                    return !schemaType?.fields?.some((field) => field.name === 'domainName');
                }),
            ]);
    };
};
